import React, {useEffect, useState} from 'react'
import {makeStyles} from '@material-ui/core/styles'
import {Box, Button, MenuItem, TextField} from '@material-ui/core'
import {connect} from 'react-redux'
import {dataActions} from '../../../../../actions'
import useForm from '../../../../../components/useForm'
import SwipeTeamDisplay from '../../../../../components/SwipeTeamDisplay'
import * as R from 'ramda'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import LookupHome from '../../../../../components/Lookup/LookupHome'

const useStyles = makeStyles(theme => ({
    titleBox: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    boundaryBox: {
        margin: '15px 0',
        fontSize: '0.825rem',
    },
    swiperbuttonBox: {
        margin: '15px 0',
        fontSize: '0.825rem',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    formControl: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        minWidth: 120,
    },
    submitButton: {
        color: theme.palette.common.white,
        backgroundColor: theme.palette.primary.main,
        margin: theme.spacing(1, 0),
        boxShadow: 'none',
        borderRadius: theme.shape.borderRadius,
        height: '2.625rem',
        textTransform: 'uppercase',
        width: '100%',
        '&:hover': {
            boxShadow: 'none',
            backgroundColor: '#00652A',
        },
    },
    swiperButton: {
        boxShadow: 'none',
        width: '48%',
        '&:hover': {
            boxShadow: 'none',
            backgroundColor: '#00000029',
        },
        '&:focus': {
            boxShadow: 'none',
            backgroundColor: '#00000029',
        },
    },
    searchBox: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        border: '1px solid',
        borderColor: theme.palette.grey.medium,
        borderRadius: theme.shape.borderRadius,
        margin: '0 0 0 5px',
        height: '40px',
    },
    input: {
        '&::placeholder': {
            fontSize: '0.70rem',
        },
    },
}))

const findValue = (formValues, value) => {
    for (let key in formValues) {
        if (
            Object.prototype.hasOwnProperty.call(formValues, key) &&
            formValues[key] === value
        ) {
            return key
        }
    }
    return null
}

const CreateDepartmentUser = props => {
    const classes = useStyles()
    const {
        token,
        addDepartmentUsers,
        lookupEUID,
        lookupEUIDresult,
        lookupEUIDPerson,
        lookupEUIDClearResults,
        clearlookupparams,
        clearlookupresults,
        departmentusers,
        department,
    } = props

    const {euid, firstName, lastName} = lookupEUIDresult

    const [userarray, setUserarray] = useState([])

    // Dialog parameters
    const [open, setOpen] = useState(false)

    const handleOpen = () => {
        setOpen(true)
    }

    const handleClose = () => {
        setOpen(false)
        clearlookupparams()
        clearlookupresults()
    }
    // End Dialog parameters

    const initFormValues = {
        usereuid: '',
        departmentrole: '',
    }

    const {values, resetField, handleChange, handleSubmit} = useForm(
        submitnewusers,
        initFormValues
    )

    function addUser() {
        lookupEUIDPerson(token, values.usereuid)
        resetField('usereuid', '')
    }

    function removeUser(euid) {
        let tempArray
        tempArray = userarray.filter(user => user.euid !== euid)
        setUserarray(tempArray)
        lookupEUIDClearResults()
    }

    let payload = {
        userarray,
        department,
        role: values.departmentrole,
    }

    function submitnewusers() {
        addDepartmentUsers(token, payload)
    }

    useEffect(() => {
        let duplicateuser = userarray.find(user => user.euid === euid)

        if (firstName && lastName && lookupEUID && !duplicateuser) {
            userarray.push({
                euid: euid,
                name: firstName + ' ' + lastName,
            })
            setUserarray([...userarray])
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [addUser])

    /* Cleanup when component dismounts */
    useEffect(() => {
        lookupEUIDClearResults()

        return () => {
            lookupEUIDClearResults()
            setUserarray([])
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const duplicateEUID =
        departmentusers.length > 0
            ? departmentusers.find(user => user.euid === values.usereuid)
            : null

    const nameerror = []
    if (!R.isNil(duplicateEUID))
        nameerror.push('This person is already assigned a department role')

    let alreadyExists
    if (departmentusers.length > 0) {
        if (userarray.length > 0)
            alreadyExists = departmentusers.find(
                deptuser => deptuser.euid === userarray[0].euid
            )
    }
    const userexistserror = []
    if (!R.isNil(alreadyExists)) {
        userexistserror.push(
            'This person is already assigned a department role'
        )
    }

    const formValid = {
        userarray: userarray.length > 0 ? true : false,
        departmentrole: values.departmentrole ? true : false,
    }

    const disableSubmit =
        findValue(formValid, false) || alreadyExists ? true : false

    return (
        <>
            <form onSubmit={handleSubmit}>
                <Box className={classes.boundaryBox}>
                    <TextField
                        id="usereuid"
                        name="usereuid"
                        label="Add User by EUID or ID number"
                        fullWidth
                        autoComplete="off"
                        margin="normal"
                        size="small"
                        variant="outlined"
                        value={values.usereuid || ''}
                        error={nameerror.length > 0 ? true : false}
                        helperText={nameerror.join()}
                        onChange={handleChange}
                    />

                    <Box className={classes.swiperbuttonBox}>
                        <Button
                            variant="outlined"
                            color="primary"
                            aria-label="add user"
                            onClick={() => addUser()}
                            size="small"
                            className={classes.swiperButton}
                            disabled={
                                !values.usereuid ||
                                nameerror.length > 0 ||
                                userarray.length > 0
                            }
                        >
                            ADD USER
                        </Button>

                        <Button
                            variant="outlined"
                            color="primary"
                            aria-label="lookup user by name"
                            onClick={handleOpen}
                            size="small"
                            className={classes.swiperButton}
                            disabled={userarray.length > 0}
                        >
                            NAME LOOKUP
                        </Button>
                    </Box>

                    <SwipeTeamDisplay
                        swiperarray={userarray}
                        removeSwiper={removeUser}
                        resetField={resetField}
                        title={'User Role'}
                        error={userexistserror}
                    />

                    {userarray.length > 0 && userexistserror.length === 0 && (
                        <TextField
                            id="departmentrole"
                            name="departmentrole"
                            label="Role"
                            select
                            fullWidth
                            autoComplete="off"
                            margin="normal"
                            size="small"
                            variant="outlined"
                            required
                            value={values.departmentrole || ''}
                            onChange={handleChange}
                        >
                            <MenuItem value={'admin'}>Administrator</MenuItem>
                            <MenuItem value={'creator'}>Creator</MenuItem>
                        </TextField>
                    )}
                </Box>
                <Box className={classes.boundaryBox}>
                    <Button
                        type="submit"
                        variant="contained"
                        size="medium"
                        disabled={disableSubmit}
                        className={classes.submitButton}
                    >
                        Assign Role
                    </Button>
                </Box>
            </form>

            <Dialog
                aria-labelledby="Look Up By Name, Birth Month and Day"
                aria-describedby="Lookup Person Modal"
                open={open}
                scroll="paper"
                fullScreen={window.innerWidth < 480}
                onClose={handleClose}
            >
                <DialogContent>
                    <LookupHome
                        exactMatchFn={'addUser'}
                        handleClose={handleClose}
                    />
                </DialogContent>
            </Dialog>
        </>
    )
}

function mapStateToProps(state) {
    return {
        token: state.authentication.token,
        lookupEUID: state.lookupEUIDdata.lookupEUID,
        lookupEUIDresult: state.lookupEUIDdata.lookupEUIDresult,
        department: state.departmentsdata.manageroledept,
        departmentusers: state.departmentusersdata.departmentuserslist,
    }
}

const mapDispatchToProps = {
    lookupEUIDPerson: (token, euid) =>
        dataActions.lookupEUIDRequest(token, euid),
    lookupEUIDClearResults: () => dataActions.lookupEUIDClearResults(),
    addDepartmentUsers: (token, payload) =>
        dataActions.departmentusersAddRequest(token, payload),
    clearlookupparams: () => dataActions.lookupClearParams(),
    clearlookupresults: () => dataActions.lookupClearResults(),
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CreateDepartmentUser)
